import { ReactElement } from 'react';
import notification from 'antd/lib/notification/index';

import { CloseIcn, MessageIcn, StatusCanceledIcn, StatusCompletedIcn, WarningIcn } from 'utils/icons';

export enum ENotificationTypes {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Message = 'message',
}

const sendNotification = (type: ENotificationTypes, message: string | ReactElement, notificationId?: string) => {
  const getStatusIcon = {
    success: <StatusCompletedIcn />,
    warning: <WarningIcn />,
    error: <StatusCanceledIcn className="text-red-50" />,
    message: <MessageIcn />,
  };
  const icon = getStatusIcon[type];

  const args: any = {
    icon,
    key: notificationId,
    message,
    className: type,
    placement: 'bottomRight',
    duration: 2,
    bottom: 20,
    closeIcon: <CloseIcn className="clickable" />,
    getContainer: () => document.getElementById('notifications') || document.body,
  };

  notification?.open(args);
};

export default sendNotification;
